module.exports = __webpack_public_path__ + "img/Matriculate-2026.1c4a8988.png";